import { createAction } from 'redux-act';

//  assigned Interview action
const assignedInterviewRequest = createAction('ASSIGNED_INTERVIEW_REQUEST', data => data);
const assignedInterviewSuccess = createAction('ASSIGNED_INTERVIEW_SUCCESS', data => data);
const assignedInterviewError = createAction('ASSIGNED_INTERVIEW_ERROR');

// get assigned Interview action
const getAssignedInterviewRequest = createAction('GET_ASSIGNED_INTERVIEW_REQUEST', data => data);
const getAssignedInterviewSuccess = createAction('GET_ASSIGNED_INTERVIEW_SUCCESS', data => data);
const getAssignedInterviewError = createAction('GET_ASSIGNED_INTERVIEW_ERROR');

// get  Interviewr  action
const getInterviewrRequest = createAction('GET_INTERVIEWR_REQUEST', data => data);
const getInterviewrSuccess = createAction('GET_INTERVIEWR_SUCCESS', data => data);
const getInterviewrError = createAction('GET_INTERVIEWR_ERROR');

// get Question By Interview Stage action
const getQuestionByInterviewStageRequest = createAction('GET_QUESTION_BY_INTERVIEW_STAGE_REQUEST', data => data);
const getQuestionByInterviewStageSuccess = createAction('GET_QUESTION_BY_INTERVIEW_STAGE_SUCCESS', data => data);
const getQuestionByInterviewStageError = createAction('GET_QUESTION_BY_INTERVIEW_STAGE_ERROR');

// fill Feedback Form action
const fillFeedbackFormRequest = createAction('FILL_FEEDBACK_FORM_REQUEST', data => data);
const fillFeedbackFormSuccess = createAction('FILL_FEEDBACK_FORM_SUCCESS', data => data);
const fillFeedbackFormError = createAction('FILL_FEEDBACK_FORM_ERROR');

// fill Feedback Form action
const getInterviewDetailsByIdRequest = createAction('GET_INTERVIEW_DETAIL_BY_ID_REQUEST', data => data);
const getInterviewDetailsByIdSuccess = createAction('GET_INTERVIEW_DETAIL_BY_ID_SUCCESS', data => data);
const getInterviewDetailsByIdError = createAction('GET_INTERVIEW_DETAIL_BY_ID_ERROR');





// clear existing Department action
const handelClearMrfInterviewStore = createAction('HANDLE_CLEAR_INTERVIEW__STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    assignedInterviewRequest,
    assignedInterviewSuccess,
    assignedInterviewError,

    getAssignedInterviewRequest,
    getAssignedInterviewSuccess,
    getAssignedInterviewError,
    
    getInterviewrRequest,
    getInterviewrSuccess,
    getInterviewrError,

    getQuestionByInterviewStageRequest,
    getQuestionByInterviewStageSuccess,
    getQuestionByInterviewStageError,

    fillFeedbackFormRequest,
    fillFeedbackFormSuccess,
    fillFeedbackFormError,

    getInterviewDetailsByIdRequest,
    getInterviewDetailsByIdSuccess,
    getInterviewDetailsByIdError,

    handelClearMrfInterviewStore,

}